import { useQuery } from '@tanstack/react-query'
import { Search } from 'lucide-react'
import { useState } from 'react'

import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { getDeveloperUsersPage } from '@/services/api/developer.service'

export function DeveloperUsersPage() {
  const [search, setSearch] = useState('')
  const { data, isLoading } = useQuery({
    queryKey: ['developer', 'users', search],
    queryFn: () => getDeveloperUsersPage({ search, page: 0, size: 100 }),
  })

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Developer Users</h1>
        <p className="mt-1 text-neutral-500">Browse users across all workspaces.</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>User Directory</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400" />
            <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by name or email" className="pl-9" />
          </div>
          <div className="grid gap-3">
            {isLoading ? (
              <p className="text-neutral-500">Loading users...</p>
            ) : data?.content?.length ? (
              data.content.map((user) => (
                <div key={user.userId} className="rounded-lg border border-neutral-200 p-4">
                  <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                    <div>
                      <p className="font-medium text-neutral-900">{user.fullName ?? 'Unnamed User'}</p>
                      <p className="text-sm text-neutral-500">{user.email}</p>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {user.workspaces.map((workspace) => (
                        <Badge key={`${user.userId}-${workspace.workspaceId}`} variant="outline">
                          {workspace.workspaceName}
                        </Badge>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="text-neutral-500">No users found.</p>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
